var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAgiBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    style: {
      height: "auto",
      width: 36
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18 0L33.5 9V27L18 36L2.5 27V9L18 0ZM17.9996 2L31.7774 10V26L17.9996 34L4.22185 26V10L17.9996 2ZM18.0032 4L30.0587 11V25L18.0032 32L5.94761 25V11L18.0032 4ZM16.7433 8L22.6396 10.8385V24.3756L16.7433 27.2141L14.5631 25.8478V9.36629L16.7433 8ZM16.4312 8.98201L15.6392 9.47836L16.4312 9.78162V8.98201ZM16.4312 10.4952L15.2295 10.0351V25.1789L16.4312 24.7184V10.4952ZM17.0976 24.4631V10.7504L20.0755 11.8906V23.322L17.0976 24.4631ZM16.4312 25.4321L15.639 25.7356L16.4312 26.2321V25.4321ZM17.0976 26.3039V25.1767L20.4179 23.9044L21.4125 24.2267L17.0976 26.3039ZM21.9732 23.708L20.7419 23.3089V11.9038L21.9732 11.5058V23.708ZM21.4117 10.9869L20.418 11.3081L17.0976 10.0368V8.91017L21.4117 10.9869Z",
    fill: "#FAE232"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAgiBlue);
export default __webpack_public_path__ + "static/media/agi-blue.7b74dddf83e9ec5639919e9fe370033a.svg";
export { ForwardRef as ReactComponent };